<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'pages3d',
})
</script>
<template>
   <div  class="bg-box box-3d" :class="device">
    <img class="logo" :style="{width:logoP.width+'px',height:logoP.height+'px',left:logoP.left+'px',top:logoP.top+'px'}" :src="addip(siteinfo.application_logo)" />
    <template v-if="menu.length>0">
    <div class="menu" :class="menuOpen?'open':''" :style="{left:menuP[i].left+'px',top:menuP[i].top+'px'}" @click="openMenu(i)" v-for="(item,i) in menu" :key="i">
        <a-tooltip :title="item.text">
      <img class="round" :class="actIndex==i?'active':''" :style="{width:menuP[i].width+'px',height:menuP[i].height+'px'}" :src="addip(item.pic)" />
        </a-tooltip>
    </div>
    </template>
    <div v-if="menuOpen" ref="content" class="content" :style="actClass">
      <div class="close" @click="close"><CloseOutlined /></div>
      <a-tabs     @change="showData"  class="flex align-center text-white">
        <a-tab-pane :tab="item.name" v-for="(item,i) in pageData.child" :key="i"></a-tab-pane>
      </a-tabs>
      <div class="data-box">
          <section class="bg-img text-left" style="color:white;width:100%" v-if="model"  :class="model.classname" :style="{backgroundColor:model.background,backgroundImage:'url('+addip(model.backgroundimg)+')'}">
              <component :is="resolveComponent(model.classname)" :data="model"></component>
          </section>
          <div class="text-grey flex align-center justify-center" style="width:100%;height:100%" v-else>  there is no content...</div>
      </div>
    </div>
   </div>
</template>

<script lang="ts" setup name="pages3d">
import { onMounted, ref,resolveComponent } from 'vue';
import {CloseOutlined,ArrowRightOutlined} from '@ant-design/icons-vue';
import { useRoute } from 'vue-router';
import api from '@/utils/http/service';
import {addip} from '@/utils/util'
import { onBeforeMount } from 'vue';
import useSiteSettings from '@/store/useSiteSettings'
  const {  device } = useSiteSettings()
  let width:Number=window.innerWidth
  let height:Number=window.innerHeight
  const logoP=ref<Object>({width:0,height:0,left:-500,top:-500})
  const menuP=ref<Array>({})

  const pageData=ref<Object>({})
  const siteinfo=ref<Object>({})
  const menu=ref<Array>([])
  const menuOpen=ref<Boolean>(false)
  const index=ref<Number>(0)
  const actIndex=ref<Number>(null)
  const actClass=ref<String>('')
  const route=useRoute()
  const dataIndex=ref<Number>(0)
  const model=ref<Object>(null)


  const getLocation=(len:Number)=>{
    if(device.value=='mobile'){
      logoP.value={width:150,height:50,left:(width-150)/2,top:20}
    }else{
      logoP.value={width:210,height:70,left:50,top:50}
    }
    let ar=[]
    for(var i=0;i<len;i++){
      if(device.value=='mobile'){
          ar.push({
            left:20+ i*width/len,
            top:height-64-30,
            width:50,
            height:50
          })
      }else{
        ar.push({
            left:logoP.value.left+logoP.value.width-64,
            top:logoP.value.top+logoP.value.height+i*100+50,
            width:64,
            height:64
          })
      }

    }
    menuP.value=ar
  }

  const getStartLogoLocation=()=>{
    if(device.value=='mobile'){
      logoP.value={width:240,height:80,left:(width-240)/2,top:50}
    }else{
      logoP.value={width:300,height:100,left:(width-300)/2,top:height*.382-50}
    }
  }
  const getStartMenuLocation=(len:Number)=>{
    let ar=[]
    for(var i=0;i<len;i++){
      if(device.value=='mobile'){
        let row=Math.floor(i/3)
          ar.push({
            left:(width-64)/2,
            top:logoP.value.top+logoP.value.height+i*120+30,
            width:64,
            height:64
          })
      }else{
          ar.push({
            left:logoP.value.left/2+i*256,
            top:logoP.value.top+logoP.value.height+ 50,
            width:128,
            height:128
          })
      }

    }
    menuP.value=ar
  }


  const openMenu=(i:Number)=>{
    if(i!=actIndex.value){
      pageData.value=[]
      actIndex.value=i
      model.value=null
      actClass.value='transform:rotateY(180deg)'
      setTimeout(()=>{
        actClass.value=''
      },300)
      var item=menu.value[i]
      if(item.url){
        var strs=item.url.split('=')
        var id=strs.at(-1)
        if(id){
          getData(id)
        }
      }
    }

    getLocation(menu.value.length)
    setTimeout(() => {
      menuOpen.value=true
    }, 500);
  }
  const close=()=>{
    menuOpen.value=false
    getStartLogoLocation()
    getStartMenuLocation(menu.value.length)
  }
  const doList=()=>{
    if(index.value<aniList.length){
      let item=aniList[index.value]
      item.method()
      setTimeout(doList,item.time*1000)
    }
  }
  const getSiteInfo=()=>{
    api.global.siteinfo().then(res=>{
        siteinfo.value=res.data
        document.title=res.data.title
        index.value++
    })
  }
  const getMenu=()=>{
      api.global.header().then(res=>{
        if(res.state==1){
          getStartMenuLocation(res.data.length)
          menu.value=res.data
        }
        index.value++
      })
  }
  const getData=(id:Number)=>{
    api.sitepage.page({id:id}).then(res=>{
            pageData.value=res.data
            if(res.data.child.length>0){
              model.value=res.data.child[0]
            }
            document.title=res.data.name
    })
  }
  const showData =(i:Number)=>{
       console.info('model',i)
    model.value=pageData.value.child[i]

  }

  let aniList=[
    {time:2,method:getSiteInfo},
    {time:3,method:getMenu}
  ]
  onMounted(()=>{
    getStartLogoLocation()
    doList()
  })

</script>
<style lang="less">
@import '@/style/main.less';
.box-3d{
  color: @white;text-align:center;position: relative;display: flex;align-items: center;justify-content: center;perspective: 3000px; perspective-origin: center bottom;width: 100vw;height:100vh;overflow: hidden;background:url(/src/assets/img/bg3d.jpg);
  a{color: @white;}
  &>*{transition: all .3s linear;}
  .logo{animation: logo 2s  linear ;position: absolute; padding:0 10px;border-left:2px solid @white-opacity-10;border-right:2px solid @white-opacity-10;}
  .menu{
    animation: menu .5s  linear ;cursor: pointer;position: absolute;
    img{border-width: 4px;border-style: solid;border-color:@white-opacity-10;transition: all .3s linear;box-shadow:rgba(0,0,0,.5) 0 0 12px ;}
  }
  .menu.open{
    display: flex ;align-items: center;justify-content: center;
    img{
      box-shadow: rgba(0,0,0,.5) -24px 24px 24px;
      &.active{border-color: @primary;}
    }
  }
  .menu:hover{
        color:@primary;
        img {box-shadow: rgba(0,0,0,.5) -64px 64px 32px;transform:scale(1.2);}
    }
  .menu.open:hover{
      .anticon{transform:translateX(20px);}

  }
  .content{box-shadow: rgba(0,0,0,.5) -24px 24px 48px;border-radius: 20px;backdrop-filter: blur(10px); animation: content .5s linear;position:relative;backdrop-filter: blur(10px);padding:40px;transform-origin:center;background-image: linear-gradient(135deg,rgba(0,0,0,.4),rgba(0,0,0,.8));box-sizing: border-box;
    .close{
      right:-40px;top:-40px;width:40px;height:40px;border-radius: 32px;position: absolute;display: flex;align-items: center;justify-content: center;box-shadow: @black 0 0 24px;background-color: @black;cursor: pointer;z-index: 100;
    }
    .ant-tabs{position:absolute;top:-100px;left:0;}
    .data-box{overflow-x: hidden;width:100%;overflow-y: auto;height: 60vh;width: 60vw;}
  }
  h1,h2,h3,h4,h5{line-height: 1.2em;padding:0;}

  &.mobile{
    padding-left:0;
    .content{
      margin-top: 20px;
      .ant-tabs {top:-60px;}
      .close{right:0}
      .data-box{width:calc(80vw - 64px);height:60vh;}
    }
  }
}

@keyframes logo{
  0%{opacity: 0;transform: translateY(-100vh);}
  30%{opacity: 1;transform:translateY(80px);}
  40%{transform:translateY(-30px)}
  50%{transform:translateY(0)}
  75%{transform:scale(1.4)}
  50%{transform:scale(1)}
}
@keyframes menu{
  0%{opacity: 0;top:-256px}
  100%{opacity: 1;}
}
@keyframes content{
  0%{opacity: 0;transform:translateY(80px);}
  100%{opacity: 1;}
}
@keyframes actcontet{
  0%{transform:translateX(0px);opacity: 0;}
  50%{opacity: 1;transform:translateX(5000px);}
  100%{transform:translateX(0px);opacity: 0;}
}
</style>
